// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/organizations/firstparty/v1/create_organization.proto

/* eslint-disable */
import {
  ApiGbrManagementType,
  apiGbrManagementTypeFromJSON,
  apiGbrManagementTypeToJSON,
  ApiLegalCountry,
  apiLegalCountryFromJSON,
  apiLegalCountryToJSON,
  ApiOrganization,
  ApiPriceRecurrence,
  apiPriceRecurrenceFromJSON,
  apiPriceRecurrenceToJSON,
} from "./organization";

/** Request message for creating an organization */
export interface ApiCreateOrganizationRequest {
  /** The organization data to create */
  readonly organization: ApiOrganizationInput | null;
}

/** Response message for creating an organization */
export interface ApiCreateOrganizationResponse {
  /** The created organization */
  readonly organization: ApiOrganization | null;
}

/** Input message for creating/updating an organization */
export interface ApiOrganizationInput {
  /** The name of the organization */
  readonly name?:
    | string
    | null
    | undefined;
  /** Indicates an existing Qonto customer that the organization was referred by */
  readonly referralCode?:
    | string
    | null
    | undefined;
  /** The organization's legal country */
  readonly legalCountry?:
    | ApiLegalCountry
    | null
    | undefined;
  /** Indicates that the tax residence of the organization may have CRS reporting requirements */
  readonly crsFlagged?:
    | boolean
    | null
    | undefined;
  /** The number of employees declared by the user during registration */
  readonly declaredNumberOfEmployeeRange?:
    | string
    | null
    | undefined;
  /** True when the organization is under creation and should go through the capital deposit flow */
  readonly underRegistration?:
    | boolean
    | null
    | undefined;
  /** The organization's VAT number */
  readonly legalTvaNumber?:
    | string
    | null
    | undefined;
  /** The first line of the organization's address */
  readonly addressLine1?:
    | string
    | null
    | undefined;
  /** The second line of the organization's address */
  readonly addressLine2?:
    | string
    | null
    | undefined;
  /** The organization's zipcode */
  readonly addressZipcode?:
    | string
    | null
    | undefined;
  /** The city where the organization is based */
  readonly addressCity?:
    | string
    | null
    | undefined;
  /** The two-letter ISO 3166-1 code of the organization's country */
  readonly addressCountry?:
    | string
    | null
    | undefined;
  /** The organization's Qonto-specific sector code */
  readonly sectorCode?:
    | string
    | null
    | undefined;
  /** The organization's Qonto-specific activity code */
  readonly activityCode?:
    | string
    | null
    | undefined;
  /** The organization's legally registered name */
  readonly legalName?:
    | string
    | null
    | undefined;
  /** The organization's legal form code */
  readonly legalFormCreditsafeCode?:
    | string
    | null
    | undefined;
  /** INSEE NAF code */
  readonly legalSector?:
    | string
    | null
    | undefined;
  /** The organization's legal number (in France, this is the SIRET) */
  readonly legalNumber?:
    | string
    | null
    | undefined;
  /** The date on which the organization was registered */
  readonly legalRegistrationDate?:
    | string
    | null
    | undefined;
  /** The total share capital of the organization (in cents) */
  readonly legalShareCapitalCents?:
    | number
    | null
    | undefined;
  /** The three-letter currency code of the legal_share_capital */
  readonly legalShareCapitalCurrency?:
    | string
    | null
    | undefined;
  /** The annual turnover range of the organization */
  readonly legalAnnualTurnOver?:
    | string
    | null
    | undefined;
  /** The net income range of the organization */
  readonly legalNetIncomeRange?:
    | string
    | null
    | undefined;
  /** The headcount of the organization */
  readonly legalNumberOfEmployeeRange?:
    | string
    | null
    | undefined;
  /** The author of the organization's bylaws */
  readonly providerSource?:
    | string
    | null
    | undefined;
  /** The contact email address of the author of the organization's bylaws */
  readonly providerSourceContactEmail?:
    | string
    | null
    | undefined;
  /** Whether the organization's activity is allowed or blacklisted by Qonto's policy */
  readonly allowedActivity?:
    | boolean
    | null
    | undefined;
  /** Turnover for the last year */
  readonly annualTurnover?:
    | string
    | null
    | undefined;
  /** Estimated number of transactions per year */
  readonly yearlyTransactionVolume?:
    | string
    | null
    | undefined;
  /** Estimated highest amount for single payment */
  readonly maxSinglePaymentAmount?:
    | number
    | null
    | undefined;
  /** Indicates what the Qonto account will be used for */
  readonly natureOfOperations: readonly string[];
  /** Management type of the organization, specific to GbR legal form */
  readonly gbrManagementType?:
    | ApiGbrManagementType
    | null
    | undefined;
  /** True when the organization is created from scratch */
  readonly companyCreationFromScratch?:
    | boolean
    | null
    | undefined;
  /** The first line of the organization's operating office address */
  readonly operatingOfficeLine1?:
    | string
    | null
    | undefined;
  /** The second line of the organization's operating office address */
  readonly operatingOfficeLine2?:
    | string
    | null
    | undefined;
  /** The organization's operating office zipcode */
  readonly operatingOfficeZipcode?:
    | string
    | null
    | undefined;
  /** The city where the organization's operating office is based */
  readonly operatingOfficeCity?:
    | string
    | null
    | undefined;
  /** The two-letter ISO 3166-1 code of the organization's operating office country */
  readonly operatingOfficeCountry?:
    | string
    | null
    | undefined;
  /** The organization's business website */
  readonly websiteUrl?:
    | string
    | null
    | undefined;
  /** The organization's net equity amount */
  readonly netEquityAmount?:
    | string
    | null
    | undefined;
  /** The organization's share capital amount */
  readonly shareCapitalAmount?:
    | string
    | null
    | undefined;
  /** The organization's net income amount */
  readonly netIncomeAmount?:
    | string
    | null
    | undefined;
  /** The source categories from where the organization's share capital is coming from */
  readonly shareCapitalOrigin: readonly string[];
  /** The freeform text for the organization's share capital origin */
  readonly shareCapitalOriginOther?:
    | string
    | null
    | undefined;
  /** The source categories from where the organization's income is coming from */
  readonly sourcesOfIncome: readonly string[];
  /** The freeform text for the organization's sources of income */
  readonly sourcesOfIncomeOther?:
    | string
    | null
    | undefined;
  /** Countries of origin and destination of the funds */
  readonly countriesOfOperations: readonly string[];
  /** Indicates whether the organization is a non-profit entity */
  readonly nonProfit?:
    | boolean
    | null
    | undefined;
  /** The code of the price plan chosen by the user at registration */
  readonly originalPricePlanCode?:
    | string
    | null
    | undefined;
  /** A discount code entered by the user when selecting their price plan */
  readonly originalVoucherCode?:
    | string
    | null
    | undefined;
  /** The recurrence chosen by the user at registration */
  readonly originalRecurrence?:
    | ApiPriceRecurrence
    | null
    | undefined;
  /** The named contact at the organization's address */
  readonly addressContactName?: string | null | undefined;
}

/** Error codes for CreateOrganization operation */
export interface ApiCreateOrganizationErrors {
}

/** Bad request error codes */
export const ApiCreateOrganizationErrorsBadRequestError = {
  /** BAD_REQUEST_ERROR_UNSPECIFIED - Unspecified bad request error */
  BAD_REQUEST_ERROR_UNSPECIFIED: "BAD_REQUEST_ERROR_UNSPECIFIED",
  /** BAD_REQUEST_ERROR_VALIDATION_FAILED - Validation failed */
  BAD_REQUEST_ERROR_VALIDATION_FAILED: "BAD_REQUEST_ERROR_VALIDATION_FAILED",
} as const;

export type ApiCreateOrganizationErrorsBadRequestError =
  typeof ApiCreateOrganizationErrorsBadRequestError[keyof typeof ApiCreateOrganizationErrorsBadRequestError];

export namespace ApiCreateOrganizationErrorsBadRequestError {
  export type BAD_REQUEST_ERROR_UNSPECIFIED =
    typeof ApiCreateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  export type BAD_REQUEST_ERROR_VALIDATION_FAILED =
    typeof ApiCreateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED;
}

export function apiCreateOrganizationErrorsBadRequestErrorFromJSON(
  object: any,
): ApiCreateOrganizationErrorsBadRequestError {
  switch (object) {
    case 0:
    case "BAD_REQUEST_ERROR_UNSPECIFIED":
      return ApiCreateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
    case 1:
    case "BAD_REQUEST_ERROR_VALIDATION_FAILED":
      return ApiCreateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED;
    default:
      return ApiCreateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  }
}

export function apiCreateOrganizationErrorsBadRequestErrorToJSON(
  object: ApiCreateOrganizationErrorsBadRequestError,
): string {
  switch (object) {
    case ApiCreateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
    case ApiCreateOrganizationErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED:
      return "BAD_REQUEST_ERROR_VALIDATION_FAILED";
    default:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
  }
}

export const ApiCreateOrganizationRequest: MessageFns<ApiCreateOrganizationRequest> = {
  fromJSON(object: any): ApiCreateOrganizationRequest {
    return { organization: isSet(object.organization) ? ApiOrganizationInput.fromJSON(object.organization) : null };
  },

  toJSON(message: ApiCreateOrganizationRequest): unknown {
    const obj: any = {};
    if (message.organization !== undefined && message.organization !== null) {
      obj.organization = ApiOrganizationInput.toJSON(message.organization);
    }
    return obj;
  },
};

export const ApiCreateOrganizationResponse: MessageFns<ApiCreateOrganizationResponse> = {
  fromJSON(object: any): ApiCreateOrganizationResponse {
    return { organization: isSet(object.organization) ? ApiOrganization.fromJSON(object.organization) : null };
  },

  toJSON(message: ApiCreateOrganizationResponse): unknown {
    const obj: any = {};
    if (message.organization !== undefined && message.organization !== null) {
      obj.organization = ApiOrganization.toJSON(message.organization);
    }
    return obj;
  },
};

export const ApiOrganizationInput: MessageFns<ApiOrganizationInput> = {
  fromJSON(object: any): ApiOrganizationInput {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : null,
      referralCode: isSet(object.referral_code) ? globalThis.String(object.referral_code) : null,
      legalCountry: isSet(object.legal_country) ? apiLegalCountryFromJSON(object.legal_country) : null,
      crsFlagged: isSet(object.crs_flagged) ? globalThis.Boolean(object.crs_flagged) : null,
      declaredNumberOfEmployeeRange: isSet(object.declared_number_of_employee_range)
        ? globalThis.String(object.declared_number_of_employee_range)
        : null,
      underRegistration: isSet(object.under_registration) ? globalThis.Boolean(object.under_registration) : null,
      legalTvaNumber: isSet(object.legal_tva_number) ? globalThis.String(object.legal_tva_number) : null,
      addressLine1: isSet(object.address_line_1) ? globalThis.String(object.address_line_1) : null,
      addressLine2: isSet(object.address_line_2) ? globalThis.String(object.address_line_2) : null,
      addressZipcode: isSet(object.address_zipcode) ? globalThis.String(object.address_zipcode) : null,
      addressCity: isSet(object.address_city) ? globalThis.String(object.address_city) : null,
      addressCountry: isSet(object.address_country) ? globalThis.String(object.address_country) : null,
      sectorCode: isSet(object.sector_code) ? globalThis.String(object.sector_code) : null,
      activityCode: isSet(object.activity_code) ? globalThis.String(object.activity_code) : null,
      legalName: isSet(object.legal_name) ? globalThis.String(object.legal_name) : null,
      legalFormCreditsafeCode: isSet(object.legal_form_creditsafe_code)
        ? globalThis.String(object.legal_form_creditsafe_code)
        : null,
      legalSector: isSet(object.legal_sector) ? globalThis.String(object.legal_sector) : null,
      legalNumber: isSet(object.legal_number) ? globalThis.String(object.legal_number) : null,
      legalRegistrationDate: isSet(object.legal_registration_date)
        ? globalThis.String(object.legal_registration_date)
        : null,
      legalShareCapitalCents: isSet(object.legal_share_capital_cents)
        ? globalThis.Number(object.legal_share_capital_cents)
        : null,
      legalShareCapitalCurrency: isSet(object.legal_share_capital_currency)
        ? globalThis.String(object.legal_share_capital_currency)
        : null,
      legalAnnualTurnOver: isSet(object.legal_annual_turn_over)
        ? globalThis.String(object.legal_annual_turn_over)
        : null,
      legalNetIncomeRange: isSet(object.legal_net_income_range)
        ? globalThis.String(object.legal_net_income_range)
        : null,
      legalNumberOfEmployeeRange: isSet(object.legal_number_of_employee_range)
        ? globalThis.String(object.legal_number_of_employee_range)
        : null,
      providerSource: isSet(object.provider_source) ? globalThis.String(object.provider_source) : null,
      providerSourceContactEmail: isSet(object.provider_source_contact_email)
        ? globalThis.String(object.provider_source_contact_email)
        : null,
      allowedActivity: isSet(object.allowed_activity) ? globalThis.Boolean(object.allowed_activity) : null,
      annualTurnover: isSet(object.annual_turnover) ? globalThis.String(object.annual_turnover) : null,
      yearlyTransactionVolume: isSet(object.yearly_transaction_volume)
        ? globalThis.String(object.yearly_transaction_volume)
        : null,
      maxSinglePaymentAmount: isSet(object.max_single_payment_amount)
        ? globalThis.Number(object.max_single_payment_amount)
        : null,
      natureOfOperations: globalThis.Array.isArray(object?.nature_of_operations)
        ? object.nature_of_operations.map((e: any) => globalThis.String(e))
        : [],
      gbrManagementType: isSet(object.gbr_management_type)
        ? apiGbrManagementTypeFromJSON(object.gbr_management_type)
        : null,
      companyCreationFromScratch: isSet(object.company_creation_from_scratch)
        ? globalThis.Boolean(object.company_creation_from_scratch)
        : null,
      operatingOfficeLine1: isSet(object.operating_office_line_1)
        ? globalThis.String(object.operating_office_line_1)
        : null,
      operatingOfficeLine2: isSet(object.operating_office_line_2)
        ? globalThis.String(object.operating_office_line_2)
        : null,
      operatingOfficeZipcode: isSet(object.operating_office_zipcode)
        ? globalThis.String(object.operating_office_zipcode)
        : null,
      operatingOfficeCity: isSet(object.operating_office_city) ? globalThis.String(object.operating_office_city) : null,
      operatingOfficeCountry: isSet(object.operating_office_country)
        ? globalThis.String(object.operating_office_country)
        : null,
      websiteUrl: isSet(object.website_url) ? globalThis.String(object.website_url) : null,
      netEquityAmount: isSet(object.net_equity_amount) ? globalThis.String(object.net_equity_amount) : null,
      shareCapitalAmount: isSet(object.share_capital_amount) ? globalThis.String(object.share_capital_amount) : null,
      netIncomeAmount: isSet(object.net_income_amount) ? globalThis.String(object.net_income_amount) : null,
      shareCapitalOrigin: globalThis.Array.isArray(object?.share_capital_origin)
        ? object.share_capital_origin.map((e: any) => globalThis.String(e))
        : [],
      shareCapitalOriginOther: isSet(object.share_capital_origin_other)
        ? globalThis.String(object.share_capital_origin_other)
        : null,
      sourcesOfIncome: globalThis.Array.isArray(object?.sources_of_income)
        ? object.sources_of_income.map((e: any) => globalThis.String(e))
        : [],
      sourcesOfIncomeOther: isSet(object.sources_of_income_other)
        ? globalThis.String(object.sources_of_income_other)
        : null,
      countriesOfOperations: globalThis.Array.isArray(object?.countries_of_operations)
        ? object.countries_of_operations.map((e: any) => globalThis.String(e))
        : [],
      nonProfit: isSet(object.non_profit) ? globalThis.Boolean(object.non_profit) : null,
      originalPricePlanCode: isSet(object.original_price_plan_code)
        ? globalThis.String(object.original_price_plan_code)
        : null,
      originalVoucherCode: isSet(object.original_voucher_code) ? globalThis.String(object.original_voucher_code) : null,
      originalRecurrence: isSet(object.original_recurrence)
        ? apiPriceRecurrenceFromJSON(object.original_recurrence)
        : null,
      addressContactName: isSet(object.address_contact_name) ? globalThis.String(object.address_contact_name) : null,
    };
  },

  toJSON(message: ApiOrganizationInput): unknown {
    const obj: any = {};
    if (message.name !== undefined && message.name !== null) {
      obj.name = message.name;
    }
    if (message.referralCode !== undefined && message.referralCode !== null) {
      obj.referral_code = message.referralCode;
    }
    if (message.legalCountry !== undefined && message.legalCountry !== null) {
      obj.legal_country = apiLegalCountryToJSON(message.legalCountry);
    }
    if (message.crsFlagged !== undefined && message.crsFlagged !== null) {
      obj.crs_flagged = message.crsFlagged;
    }
    if (message.declaredNumberOfEmployeeRange !== undefined && message.declaredNumberOfEmployeeRange !== null) {
      obj.declared_number_of_employee_range = message.declaredNumberOfEmployeeRange;
    }
    if (message.underRegistration !== undefined && message.underRegistration !== null) {
      obj.under_registration = message.underRegistration;
    }
    if (message.legalTvaNumber !== undefined && message.legalTvaNumber !== null) {
      obj.legal_tva_number = message.legalTvaNumber;
    }
    if (message.addressLine1 !== undefined && message.addressLine1 !== null) {
      obj.address_line_1 = message.addressLine1;
    }
    if (message.addressLine2 !== undefined && message.addressLine2 !== null) {
      obj.address_line_2 = message.addressLine2;
    }
    if (message.addressZipcode !== undefined && message.addressZipcode !== null) {
      obj.address_zipcode = message.addressZipcode;
    }
    if (message.addressCity !== undefined && message.addressCity !== null) {
      obj.address_city = message.addressCity;
    }
    if (message.addressCountry !== undefined && message.addressCountry !== null) {
      obj.address_country = message.addressCountry;
    }
    if (message.sectorCode !== undefined && message.sectorCode !== null) {
      obj.sector_code = message.sectorCode;
    }
    if (message.activityCode !== undefined && message.activityCode !== null) {
      obj.activity_code = message.activityCode;
    }
    if (message.legalName !== undefined && message.legalName !== null) {
      obj.legal_name = message.legalName;
    }
    if (message.legalFormCreditsafeCode !== undefined && message.legalFormCreditsafeCode !== null) {
      obj.legal_form_creditsafe_code = message.legalFormCreditsafeCode;
    }
    if (message.legalSector !== undefined && message.legalSector !== null) {
      obj.legal_sector = message.legalSector;
    }
    if (message.legalNumber !== undefined && message.legalNumber !== null) {
      obj.legal_number = message.legalNumber;
    }
    if (message.legalRegistrationDate !== undefined && message.legalRegistrationDate !== null) {
      obj.legal_registration_date = message.legalRegistrationDate;
    }
    if (message.legalShareCapitalCents !== undefined && message.legalShareCapitalCents !== null) {
      obj.legal_share_capital_cents = Math.round(message.legalShareCapitalCents);
    }
    if (message.legalShareCapitalCurrency !== undefined && message.legalShareCapitalCurrency !== null) {
      obj.legal_share_capital_currency = message.legalShareCapitalCurrency;
    }
    if (message.legalAnnualTurnOver !== undefined && message.legalAnnualTurnOver !== null) {
      obj.legal_annual_turn_over = message.legalAnnualTurnOver;
    }
    if (message.legalNetIncomeRange !== undefined && message.legalNetIncomeRange !== null) {
      obj.legal_net_income_range = message.legalNetIncomeRange;
    }
    if (message.legalNumberOfEmployeeRange !== undefined && message.legalNumberOfEmployeeRange !== null) {
      obj.legal_number_of_employee_range = message.legalNumberOfEmployeeRange;
    }
    if (message.providerSource !== undefined && message.providerSource !== null) {
      obj.provider_source = message.providerSource;
    }
    if (message.providerSourceContactEmail !== undefined && message.providerSourceContactEmail !== null) {
      obj.provider_source_contact_email = message.providerSourceContactEmail;
    }
    if (message.allowedActivity !== undefined && message.allowedActivity !== null) {
      obj.allowed_activity = message.allowedActivity;
    }
    if (message.annualTurnover !== undefined && message.annualTurnover !== null) {
      obj.annual_turnover = message.annualTurnover;
    }
    if (message.yearlyTransactionVolume !== undefined && message.yearlyTransactionVolume !== null) {
      obj.yearly_transaction_volume = message.yearlyTransactionVolume;
    }
    if (message.maxSinglePaymentAmount !== undefined && message.maxSinglePaymentAmount !== null) {
      obj.max_single_payment_amount = Math.round(message.maxSinglePaymentAmount);
    }
    if (message.natureOfOperations?.length) {
      obj.nature_of_operations = message.natureOfOperations;
    }
    if (message.gbrManagementType !== undefined && message.gbrManagementType !== null) {
      obj.gbr_management_type = apiGbrManagementTypeToJSON(message.gbrManagementType);
    }
    if (message.companyCreationFromScratch !== undefined && message.companyCreationFromScratch !== null) {
      obj.company_creation_from_scratch = message.companyCreationFromScratch;
    }
    if (message.operatingOfficeLine1 !== undefined && message.operatingOfficeLine1 !== null) {
      obj.operating_office_line_1 = message.operatingOfficeLine1;
    }
    if (message.operatingOfficeLine2 !== undefined && message.operatingOfficeLine2 !== null) {
      obj.operating_office_line_2 = message.operatingOfficeLine2;
    }
    if (message.operatingOfficeZipcode !== undefined && message.operatingOfficeZipcode !== null) {
      obj.operating_office_zipcode = message.operatingOfficeZipcode;
    }
    if (message.operatingOfficeCity !== undefined && message.operatingOfficeCity !== null) {
      obj.operating_office_city = message.operatingOfficeCity;
    }
    if (message.operatingOfficeCountry !== undefined && message.operatingOfficeCountry !== null) {
      obj.operating_office_country = message.operatingOfficeCountry;
    }
    if (message.websiteUrl !== undefined && message.websiteUrl !== null) {
      obj.website_url = message.websiteUrl;
    }
    if (message.netEquityAmount !== undefined && message.netEquityAmount !== null) {
      obj.net_equity_amount = message.netEquityAmount;
    }
    if (message.shareCapitalAmount !== undefined && message.shareCapitalAmount !== null) {
      obj.share_capital_amount = message.shareCapitalAmount;
    }
    if (message.netIncomeAmount !== undefined && message.netIncomeAmount !== null) {
      obj.net_income_amount = message.netIncomeAmount;
    }
    if (message.shareCapitalOrigin?.length) {
      obj.share_capital_origin = message.shareCapitalOrigin;
    }
    if (message.shareCapitalOriginOther !== undefined && message.shareCapitalOriginOther !== null) {
      obj.share_capital_origin_other = message.shareCapitalOriginOther;
    }
    if (message.sourcesOfIncome?.length) {
      obj.sources_of_income = message.sourcesOfIncome;
    }
    if (message.sourcesOfIncomeOther !== undefined && message.sourcesOfIncomeOther !== null) {
      obj.sources_of_income_other = message.sourcesOfIncomeOther;
    }
    if (message.countriesOfOperations?.length) {
      obj.countries_of_operations = message.countriesOfOperations;
    }
    if (message.nonProfit !== undefined && message.nonProfit !== null) {
      obj.non_profit = message.nonProfit;
    }
    if (message.originalPricePlanCode !== undefined && message.originalPricePlanCode !== null) {
      obj.original_price_plan_code = message.originalPricePlanCode;
    }
    if (message.originalVoucherCode !== undefined && message.originalVoucherCode !== null) {
      obj.original_voucher_code = message.originalVoucherCode;
    }
    if (message.originalRecurrence !== undefined && message.originalRecurrence !== null) {
      obj.original_recurrence = apiPriceRecurrenceToJSON(message.originalRecurrence);
    }
    if (message.addressContactName !== undefined && message.addressContactName !== null) {
      obj.address_contact_name = message.addressContactName;
    }
    return obj;
  },
};

export const ApiCreateOrganizationErrors: MessageFns<ApiCreateOrganizationErrors> = {
  fromJSON(_: any): ApiCreateOrganizationErrors {
    return {};
  },

  toJSON(_: ApiCreateOrganizationErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
